import React from 'react'

import { Button, Modal as AntModal } from 'antd'
import Steps from './Steps.jsx'

export default function Modal() {
  const [visible, setVisible] = React.useState(false)
  const [counter, setCounter] = React.useState(0)

  React.useEffect(() => {
  })

  const showModal = () => {
    setCounter(counter + 1)
    setVisible(true)
  }

  const handleCancel = () => {
    setVisible(false)
  }

  return <>
    <Button type="primary" onClick={showModal} size="large">Update from CSV</Button>
    <AntModal
      open={visible}
      title="Update Items from CSV"
      onCancel={handleCancel}
      footer={null}
      width={850}
    >
      <Steps finish={handleCancel} openCounter={counter}/>
    </AntModal>
  </>
}
